module.exports = __webpack_public_path__ + "img/intro_mo_img03.77429277.png";